import React from 'react';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import useOnMount from 'ui-library/hooks/useOnMount';
import {BasicEvent} from 'util/Types';

export default function InformationPanelNameInput(props: {
  archiveRecord: ArchiveRecord | null;
  id: string;
  isWritable: boolean;
  name: string;
  onChange: (e: BasicEvent) => void;
  onMount?: () => void;
}): JSX.Element {
  useOnMount(() => {
    props.onMount?.();
  });

  return (
    <div>
      {props.isWritable ? (
        <input
          id="info-name"
          type="text"
          className="info-name-input"
          onChange={props.onChange}
          value={props.name}
        />
      ) : (
        props.name
      )}
      <ArchiveRecordLabel item={{id: props.id, archiveRecord: props.archiveRecord, name: props.name}} />
    </div>
  );
}
